/// \file timestampToDate.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import * as React from "react";
//data will have the data to check in
//checkString will hold a string that we hope data contains

export const TimestampToDate = (props:{timestamp:string,numberPass?:boolean}) => {
    let timestamp = props.timestamp;
    const numberPass = props.numberPass?props.numberPass:false;
    let dateString = "";
    let passIn:any = timestamp
    if(timestamp){
        if(passIn=="---" || passIn==0){
            return("---");
        }
        if(numberPass){
            passIn = Number(timestamp);
        }
        if(passIn==0){
            return("---")
        }
        const dateObject = new Date(passIn);
        const month = dateObject.getMonth()+1;
        const day = dateObject.getDate();
        const year = dateObject.getFullYear();
        let AMPM = "AM";
        let hour = dateObject.getHours().toString();
        if(parseInt(hour)==12){
            AMPM = "PM";
        }
        if(parseInt(hour)==0){
            AMPM = "AM";
            hour = "12";
        }
        if(parseInt(hour)>=13){
            hour = (parseInt(hour)-12).toString();
            AMPM = "PM";
        }
        if(parseInt(hour)<10){
            hour = "0"+hour.toString();
        }
        let minute = dateObject.getMinutes().toString();
        if(parseInt(minute)<10){
            minute = "0"+minute.toString();
        }
        let second = dateObject.getSeconds().toString();
        if(parseInt(second)<10){
            second = "0"+second.toString();
        }
        dateString = (month+"/"+day+"/"+year+" "+hour+":"+minute+":"+second+" "+AMPM);
    }
    else{
        dateString = ""; 
    }
    return (dateString);
};